import { removeTabs } from "../../../utils/format";

/* eslint-disable no-loop-func */
export const initialColsSelector = (columnDefs) => {
  return columnDefs.map((d) => {
    return { colId: d.field, headerName: d.headerName, hide: d.hide };
  });
};

export const onChangeColumns = (newColumns, columnDefs) => {
  let cols = [];
  let column;
  for (let i = 0; i < columnDefs.length; i++) {
    column = newColumns.find((f) => f.colId.replace("_1", "") === columnDefs[i].field);
    cols.push({ colId: column.colId, headerName: columnDefs[i].headerName, hide: column.hide });
  }
  return cols;
};

export const exportGrid = (exportParams) => {
  let { fileName, api, columnKeys } = exportParams;
  let file = prompt("Guardar como: ", fileName);

  if (file !== null && file !== "") {
    var params = {
      columnKeys: columnKeys,
      skipHeader: false,
      skipFooters: true,
      skipGroups: true,
      suppressQuotes: true,
      columnSeparator: "\t",
      fileName: file + ".xls",
    };

    params.processCellCallback = function (params) {
      const data = params.node.data;
      const newParams = { ...params, ...{ data: data } };
      if (params.value !== null && params.value !== undefined && !params.node.rowPinned) {
        return params.column.colDef.valueFormatter
          ? (params.column.colDef.type === "" ? removeTabs(params.column.colDef.valueFormatter(newParams)) : params.column.colDef.valueFormatter(newParams))
          : removeTabs(params.value);
      } else {
        return "";
      }
    };

    params.processHeaderCallback = function (params) {
      return params.column.colDef.headerName;//params.column.colId;
    };

    var data = api.getDataAsCsv(params);

    // Turn our binary result into a blob
    const buf = new ArrayBuffer(data.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i != data.length; ++i) view[i] = data.charCodeAt(i) & 0xff;
    const blob = new Blob([buf], {
      type: "application/octet-stream",
    });

    // Automatically download the file by appending an a element,
    // 'clicking' it, and removing the element
    const a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob, {
      type: "data:attachment/xls",
    });
    a.download = file + ".xls";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } else {
    if (file !== null) {
      api.onExport();
    }
  }
};

export const getLocaleText = (translate) => {
  if(translate!==undefined){
    return {
      equals: `${translate('igual-a')}..`,
      notEqual: `${translate('distinto-de')}..`,
      lessThan: `${translate('menor-que')}..`,
      greaterThan: `${translate('mayor-que')}..`,
      lessThanOrEqual: `${translate('menor-o-igual-que')}..`,
      greaterThanOrEqual: `${translate('mayor-o-igual-que')}..`,
      contains: `${translate('contiene')}..`,
      notContains: `${translate('no-contiene')}..`,
      startsWith: `${translate('empieza-por')}..`,
      endsWith: `${translate('termina-por')}..`,
      inRange: `${translate('entre')}..`,
      noRowsToShow: `${translate('no-hay-registros')}..`,
      filterOoo: `${translate('filtrar')}..`,
      andCondition: `${translate('y').toUpperCase()}`,
      orCondition: `${translate('o').toUpperCase()}`,
      resetFilter: `${translate('resetear')}`,
      empty: `${translate('filtrar-por')}`,
      blanks: `${translate('en-blanco')}`
    };
  }else{
    return {
      equals: "Igual a..",
      notEqual: "Distinto de..",
      lessThan: "Menor que..",
      greaterThan: "Mayor que..",
      lessThanOrEqual: "Menor o igual que..",
      greaterThanOrEqual: "Mayor o igual que..",
      contains: "Contiene..",
      notContains: "No contiene..",
      startsWith: "Empieza por..",
      endsWith: "Termina por..",
      inRange: "Entre..",
      noRowsToShow: "No hay datos para mostrar",
      filterOoo: 'Filtrar...',
      andCondition: "Y",
      orCondition: "O",
      resetFilter: 'Resetear',
      empty: 'Filtrar Por',
      blanks: 'En Blanco'
    };
  }
};

export const LiteralTotalRegistros = (translate) => (translate !==undefined ? `${translate('total-registros')}:` : 'Total Registros:')

export * from "./columnFactory";
export * from "./copyToClipboard";
export * from "./pinnedBottom";
export * from "./customFilters";
